module.exports = "<vg-player [hidden] = \"!isPlaying\" (onPlayerReady)=\"onPlayerReady($event)\" style=\"height: 100%\">\n    <video [vgMedia]=\"media\" #media id=\"singleVideo\" preload=\"auto\" style=\"object-fit: cover;\">\n        <source [src]=\"url\" type=\"video/mp4\">\n    </video>\n</vg-player>"


//////////////////
// WEBPACK FOOTER
// ./src/app/video/video.component.html
// module id = ./src/app/video/video.component.html
// module chunks = main